// eslint-disable-next-line import/no-unresolved
import Genie from '@creditsights/cs-genie-web';
import React, { useEffect } from 'react';
import { ROUTES } from '../../Base.constants';
import useFetchUserProfile from '../../hooks/profile/useFetchUserProfile';

const prepareLayout = () => {
  const header = document.getElementsByTagName('header')[0];
  if (header) {
    header.style.display = 'none';
  }

  const footer = document.getElementsByTagName('footer')[0];
  if (footer) {
    footer.style.display = 'none';
  }

  const main = document.getElementsByTagName('main')[0]?.children[0] as HTMLDivElement;
  if (main) {
    main.style.minHeight = '0px';
  }
};

if (window.location.pathname.startsWith(ROUTES.genieStandalone)) {
  prepareLayout();
}

const GenieStandalone = (): React.ReactElement => {
  const { data: profile } = useFetchUserProfile();

  useEffect(() => {
    prepareLayout();
  }, []);

  return (
    <Genie
      userData={{
        csUserId: profile?.userId,
        userId: profile?.email,
        userFirstName: profile?.firstName,
        userLastName: profile?.lastName,
      }}
      standalone
    />
  );
};

export default GenieStandalone;
